<div *ngIf="productInfo" id="cart" class="p-4 cart">
  <app-cart-steps [step]="step" [steps]="steps" (stepClick)="goToStep($event)"></app-cart-steps>
  <div class="cart__content">
    <ng-container *ngIf="step === 1">
      <div *ngIf="orderItems.length > 0; else noItemsMessage" class="cart__table-wrapper">
        <table mat-table [dataSource]="orderItems" class="cart__table">
          <ng-container matColumnDef="name">
            <ng-template #nameColumnHeaderCaption i18n="Product name|Column heading for the product table in the cart"
              >Name</ng-template
            >

            <th mat-header-cell *matHeaderCellDef>
              <ng-container *ngTemplateOutlet="nameColumnHeaderCaption"></ng-container>
            </th>
            <td mat-cell *matCellDef="let item">
              <span class="mobile-label">
                <ng-container *ngTemplateOutlet="nameColumnHeaderCaption"></ng-container>
              </span>
              <span [matTooltip]="item.name" matTooltipPosition="above">
                <span class="value">{{ item.name }}</span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="date">
            <ng-template #dateColumnHeaderCaption i18n="Experience dates|Column heading for the cart item table"
              >Dates</ng-template
            >

            <th mat-header-cell *matHeaderCellDef>
              <ng-container *ngTemplateOutlet="dateColumnHeaderCaption"></ng-container>
            </th>

            <td mat-cell *matCellDef="let item">
              <span class="mobile-label"
                ><ng-container *ngTemplateOutlet="dateColumnHeaderCaption"></ng-container
              ></span>
              <span class="value">{{ humaneDateTime(item) }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="participants">
            <ng-template #participantsColumnHeaderCaption>
              <ng-container *ngIf="isHotel" i18n="Number of hotel rooms|Column heading for the cart item table."
                >Rooms</ng-container
              >

              <ng-container *ngIf="!isHotel" i18n="Experience participants|Column heading for the cart item table."
                >Participants</ng-container
              >
            </ng-template>

            <th mat-header-cell *matHeaderCellDef>
              <ng-container *ngTemplateOutlet="participantsColumnHeaderCaption"></ng-container>
            </th>

            <td mat-cell *matCellDef="let item">
              <span class="mobile-label">
                <ng-container *ngTemplateOutlet="participantsColumnHeaderCaption"></ng-container>
              </span>

              <span *ngIf="isHotel; else participants" class="value">
                {{ item.roomQuantity }}
                {{ getAdditionalBedsQuantity(item) ? '(' + getAdditionalBedsQuantity(item) + ' extra beds)' : '' }}
              </span>

              <ng-template #participants>
                <div class="value participants" *ngFor="let scheme of item.optionQuantities">
                  {{ scheme.quantity }} {{ scheme.name === 'Group' ? 'persons' : scheme.name }}
                </div>
              </ng-template>
            </td>
          </ng-container>

          <ng-container matColumnDef="price">
            <ng-template #priceColumnHeaderCaption i18n="Experience price|Column heading for the cart item table"
              >Price</ng-template
            >

            <th mat-header-cell *matHeaderCellDef>
              <ng-container *ngTemplateOutlet="priceColumnHeaderCaption"></ng-container>
            </th>

            <td mat-cell *matCellDef="let item">
              <span class="mobile-label">
                <ng-container *ngTemplateOutlet="priceColumnHeaderCaption"></ng-container>
              </span>

              <span class="value">
                {{ item.totalPrice | appCurrency: productInfo.currency }}
                <ng-container>{{ getHotelPricingSchemasUi(item) }}</ng-container>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
              <ng-container i18n="Cart item actions|Column heading for the cart item table, e.g. “Delete”"
                >Actions</ng-container
              >
            </th>

            <td mat-cell *matCellDef="let item; let i = index">
              <button class="remove" mat-icon-button color="warn" (click)="removeProduct(i)">
                <mat-icon aria-label="Remove product">delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <div *ngIf="orderItems.length > 0" class="container">
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <div class="price mt-2">
              <div *ngIf="!isPartnerUsingPaynet" class="d-flex justify-content-between">
                <span i18n="Experience price|Column heading for the cart item table">Price</span>
                <span>{{ basketCost | appCurrency: productInfo.currency }}</span>
              </div>
              <div *ngIf="!isPartnerUsingPaynet" class="d-flex justify-content-between">
                <span
                  i18n="Customer additional fee|Displayed below the item table, before the grand total price e.g. €205."
                  >Booking Fee</span
                >
                <span>{{ additionalFee | appCurrency: productInfo.currency }}</span>
              </div>
              <div class="d-flex justify-content-between font-weight-bold border-top pt-1">
                <span
                  i18n="Cart grand total caption|Displayed below the item table, before the grand total price e.g. €205"
                  >Total</span
                >
                <span>{{ totalCost | appCurrency: productInfo.currency }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noItemsMessage>
        <span class="cart__empty-text" i18n="Cart empty message|Displayed when there are no item added to the cart."
          >Shopping cart is empty!</span
        >
      </ng-template>
    </ng-container>

    <ng-container *ngIf="step === 2">
      <form id="personalInfo" class="personal" [formGroup]="personalInfo" (ngSubmit)="next()">
        <div class="row">
          <ng-template
            #requiredErrorMessage
            i18n="Required error message|Message displayed next to any field that is required and was not filled in"
            >This field is required</ng-template
          >

          <div class="col-12 col-sm-6">
            <mat-form-field class="w-100 mb-1">
              <input
                matInput
                i18n-placeholder="First name field label|Displayed in the “Order info” section of the checkout flow"
                placeholder="First name"
                formControlName="firstName"
                test-id="first-name-in-order-info"
              />
              <mat-error
                *ngIf="
                  personalInfo.controls['firstName'].invalid && personalInfo.controls['firstName'].errors['required']
                "
              >
                <ng-container *ngTemplateOutlet="requiredErrorMessage"></ng-container
              ></mat-error>
            </mat-form-field>
          </div>

          <div class="col-12 col-sm-6">
            <mat-form-field class="w-100 mb-1">
              <input
                matInput
                i18n-placeholder="Last name field label|Displayed in the “Order info” section of the checkout flow"
                placeholder="Last name"
                formControlName="lastName"
                test-id="last-name-in-order-info"
              />
              <mat-error
                *ngIf="
                  personalInfo.controls['lastName'].invalid && personalInfo.controls['lastName'].errors['required']
                "
              >
                <ng-container *ngTemplateOutlet="requiredErrorMessage"></ng-container
              ></mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6">
            <mat-form-field class="w-100 mb-1">
              <input
                matInput
                i18n-placeholder="Email field label|Displayed in the “Order info” section of the checkout flow"
                placeholder="Email"
                formControlName="email"
                test-id="email-field"
              />
              <mat-error *ngIf="personalInfo.controls['email'].invalid">
                <span *ngIf="personalInfo.controls['email'].errors['required']"
                  ><ng-container *ngTemplateOutlet="requiredErrorMessage"></ng-container
                ></span>
                <span *ngIf="personalInfo.controls['email'].errors['customEmail']">
                  <ng-container
                    i18n="Syntactically incorrect email error message|Error displayed next to the Email field"
                    >Please enter a valid email</ng-container
                  >
                </span>
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-12 col-sm-6">
            <mat-form-field class="w-100 mb-1">
              <input
                matInput
                i18n-placeholder="Confirm Email field label|Displayed in the “Order info” section of the checkout flow"
                placeholder="Confirm email"
                formControlName="emailConfirm"
                autocomplete="off"
                test-id="confirm-email-field"
              />
              <mat-error
                *ngIf="
                  personalInfo.controls['emailConfirm'].invalid &&
                  personalInfo.controls['emailConfirm'].errors['confirm']
                "
              >
                <ng-container
                  i18n="Email confirmation does not match errror message|Displayed next to the Email Confirmation field"
                  >Email not confirmed</ng-container
                >
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6">
            <mat-form-field class="w-100 mb-1">
              <input
                matInput
                i18n-placeholder="Phone field label|Displayed in the “Order info” section of the checkout flow"
                placeholder="Phone"
                formControlName="phone"
                test-id="phone-field"
              />
              <mat-error *ngIf="personalInfo.controls['phone'].invalid">
                <span *ngIf="personalInfo.controls['phone'].errors['required']"
                  ><ng-container *ngTemplateOutlet="requiredErrorMessage"></ng-container
                ></span>
                <span
                  *ngIf="personalInfo.controls['phone'].errors['customPhone']"
                  i18n="Invalid phone number errror message|When it seems syntactically incorrect"
                  >Please enter a valid phone number</span
                >
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-12 col-sm-6">
            <mat-form-field class="w-100 mb-1">
              <input
                matInput
                i18n-placeholder="Voucher field label|Displayed in the “Order info” section of the checkout flow"
                placeholder="Voucher"
                formControlName="voucher"
              />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="w-100 mb-1">
              <textarea
                matInput
                i18n-placeholder="Comments field label|Displayed in the “Order info” section of the checkout flow"
                placeholder="Comments"
                formControlName="comments"
                class="personal__comments"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </form>
    </ng-container>

    <ng-container *ngIf="productInfo && !isPartnerUsingPaynet && step === 3">
      <app-cart-payment
        [symbol]="productInfo.currency"
        [amount]="totalCost"
        [orderData]="getOrderData()"
        (response)="handleStripe($event)"
      ></app-cart-payment>
    </ng-container>

    <ng-container *ngIf="step === 4">
      <ng-template #successPayment>
        <i class="material-icons text-success">check_circle_outline</i>
        <h2 test-id="success-message">
          <ng-template i18n="Title of the Payment Successful page|Displayed in the last section of the checkout flow"
            >Success</ng-template
          >
        </h2>

        <p>
          <ng-container
            i18n="Realtime booking payment confirmation message|Displayed in the last section of the checkout flow"
            >Your booking was successfully created.</ng-container
          >
        </p>
      </ng-template>

      <ng-template #failPayment>
        <i class="material-icons text-danger">highlight_off</i>
        <h2 i18n="Title of the Payment Fail page|Displayed in the last section of the checkout flow">Fail</h2>

        <p>
          <ng-container i18n="Fail booking payment message|Displayed in the last section of the checkout flow"
            >Your booking was not created.</ng-container
          >
        </p>
      </ng-template>

      <div class="cart__status">
        <ng-container *ngIf="isSuccessStatus; then successPayment; else failPayment"></ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="waitingResponse">
      <div class="spinner-container">
        <mat-spinner mode="indeterminate"></mat-spinner>
      </div>
    </ng-container>
  </div>

  <p class="mat-error text-center">{{ this.errorMessage }}</p>

  <div class="container">
    <ng-template #buttonPreviousCaption i18n="Caption for the “Previous” button|Used for navigating the checkout flow"
      >Previous</ng-template
    >
    <ng-template #buttonNextCaption i18n="Caption for the “Next” button|Used for navigating the checkout flow"
      >Next</ng-template
    >

    <div class="row">
      <div class="col-6">
        <button *ngIf="step === 1 || step === 4" mat-button class="cart__back-to-list" (click)="backToList()">
          <ng-container *ngIf="isSoloMode" [ngTemplateOutlet]="buttonPreviousCaption"></ng-container>
          <ng-container
            *ngIf="!isSoloMode"
            i18n="Caption for the “Back to list” button|Displayed in the last section of the checkout flow"
            >Back to list</ng-container
          >
        </button>

        <button
          *ngIf="step > 1 && step <= 3"
          mat-button
          class="cart__previous"
          (click)="previous()"
          [disabled]="waitingResponse"
        >
          <ng-container *ngTemplateOutlet="buttonPreviousCaption"></ng-container>
        </button>
      </div>

      <div class="col-6 text-right">
        <ng-container *ngIf="step <= 2">
          <button
            *ngIf="step !== 2"
            mat-button
            class="cart__next"
            cdkFocusInitial
            (click)="next()"
            [disabled]="waitingResponse"
            test-id="next-button"
          >
            <span *ngIf="!waitingResponse">
              <ng-container *ngTemplateOutlet="buttonNextCaption"></ng-container>
            </span>
          </button>

          <button
            *ngIf="step === 2"
            mat-button
            class="cart__next"
            cdkFocusInitial
            type="submit"
            form="personalInfo"
            [disabled]="waitingResponse"
            test-id="next-button"
          >
            <ng-container *ngTemplateOutlet="buttonNextCaption"></ng-container>
          </button>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<hr />
<app-footer [footerLogo]="true"></app-footer>
